var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTypography = function SvgTypography(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "typo_a",
    d: "M25.31 41.775l-2.38-.893 6.734-17.956a2.966 2.966 0 0 1 5.555 0l6.733 17.956-2.38.893-6.734-17.957a.424.424 0 0 0-.794 0l-6.733 17.957zm-3.039.825a1.271 1.271 0 0 1 0-2.542h4.623a1.271 1.271 0 1 1 0 2.542h-4.623zm15.717 0a1.271 1.271 0 0 1 0-2.542h4.623a1.271 1.271 0 0 1 0 2.542h-4.623zm-11.094-7.396a1.271 1.271 0 1 1 0-2.543h10.17a1.271 1.271 0 1 1 0 2.543h-10.17z"
  })));
};
export default SvgTypography;